export default __webpack_public_path__ + "7d27a7e90d5a5dc2a1d4d24e0c5c8475.png";